import { getConfigApi } from '../config'
import { deleteFetch, getFetch, postFetch, putFetch } from '../utils/fetch'

export function getUrl(prefix = '') {
  return getConfigApi().languageLocale + '/' + prefix
}

export function getLanguageLocales() {
  return getFetch(getUrl())
}

export function getLanguageLocale(key) {
  return getFetch(getUrl(key))
}

export function createLanguageLocale(languageLocale = {}) {
  return postFetch(getUrl(), languageLocale)
}

export function updateLanguageLocale(key, languageLocale = {}) {
  return putFetch(getUrl(key), languageLocale)
}

export function deleteLanguageLocale(key) {
  return deleteFetch(getUrl(key))
}

export default {
  getLanguageLocales,
  getLanguageLocale,
  createLanguageLocale,
  updateLanguageLocale,
  deleteLanguageLocale
}



// WEBPACK FOOTER //
// ./src/api/LanguageLocaleApi.js